import Rest from '@/services/rest/Rest'

export default class RestResource extends Rest {
    constructor (config) {
        super(config)
        this.restInstance = new Rest(this.config)
    }

    handleResponse (responsePromise) {
      const promise = new Promise((resolve, reject) => {
        responsePromise
          .then(response => {
            // If this is a wrapped with a status builder, handle it as such
            if (response.isSuccessful === undefined) {
              const data = response.data === undefined ? response : response.data
              resolve(data)
            } else {
              // This is a status builder response, so handle it as such
              if (response.isSuccessful) {
                resolve(response.data)
              } else {
                reject(response.message)
              }
            }
          })
          .catch(error => {
            reject(error)
          })
      })

      return promise
    }

    getFrom (endpoint, constraints) {
      var url = endpoint
      if (constraints) {
        url = endpoint + JSON.stringify(constraints)
      }
      return this.handleResponse(this.restInstance.get(url))
    }

    query (constraints) {
      return this.getFrom('query/', constraints)
    }

    // Gets all resources
    getList (params = null) {
        return this.handleResponse(this.restInstance.get('', params))
    }

    // Gets a specific resource by id
    get (id, params = null) {
        return this.handleResponse(this.restInstance.get(id, params))
    }

    // Create a new resource
    post (data = null, endpoint = '') {
        return this.handleResponse(this.restInstance.post(endpoint, data))
    }

    // Updates the resource identified by id
    put (id, data = null) {
        return this.handleResponse(this.restInstance.put(id, data))
    }

    // Update a specific attribute on a resource
    patch (id, field, value) {
        return this.handleResponse(this.restInstance.patch(id, { field, value }))
    }

    // Delete resource by the id specified
    delete (id, data = null) {
        return this.handleResponse(this.restInstance.delete(id, data))
    }

    // Will call a put or a post based on attributes found in the model
    save (model, key = 'id') {
        // If it has an id, it is an update / put
        if (model[key]) {
            return this.put(model[key], model)
        } else {
            return this.post(model)
        }
    }
}
